import { prop, propArray, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "./case";
import { User } from "../../users/_types/user";
import { CaseLogType } from "./case-log-type";
import { IntegrationEvent } from "../../companies/_types/integration-event";
import { CaseLogFile } from "./case-log-file";

export enum CaseLogResourceType {
    Mail = "Mail",
    Call = "Call",
    SMS = "SMS",
    Chat = "Chat",
    Manual = "Manual",
    
    Incident = "Incident"
}
/*
export enum CaseLogLevel {
    Info = "Info",
    Warning = "Warning",
    Danger = "Danger"
}
*/

export enum CaseLogDirection {
    In = "In",
    Out = "Out"
}

export class CaseLog extends Resource {
    public override type = 'caseLogs';

    @prop()
    @required()
    public caseId!: string;

    public case: Case = new Case();
    
    @prop()
    @required()
    public date: Date = new Date();

    @prop()
    @required()
    public message!: string;
    @prop()
    public resourceType: CaseLogResourceType = CaseLogResourceType.Mail;
    
   /* @prop()
    public caseLogLevel: CaseLogLevel  = CaseLogLevel.Info;*/

    @prop()
    public direction: CaseLogDirection  = CaseLogDirection.In;
    
    @prop()
    public subject!: string;

    @prop()
    public resourceId!: string;

    @propObject()
    public createdByUser?: User;

    @prop()
    public caseLogTypeId?: string;

    
    @prop()
    public caseLogType?: CaseLogType;

    @prop()    
    public completedAt?: Date | null;

    @prop()    
    public completedById?:string | null;

    @propObject()
    public CompletedByUser?: User;

    @prop()
    public integrationEventId?: string;

    @propObject()
    public integrationEvent?: IntegrationEvent;

    @propArray()
    public recipients: CaseLogFile[] = [];

    /** Meta-información libre del evento. Las respuestas del formulario del tipo van en la clave 'fields'. */
    @prop()
    public caseLogMetadata?: any;

}